// eslint-disable-next-line no-restricted-imports -- pre-existing Immutable usage; migrate off when touched
import { Set } from 'immutable';

import { ADD_TOAST, REMOVE_TOASTS } from '@sophocles/features/toast/toastActions';

function toastReducer(state = Set(), action) {
  switch (action.type) {
    case ADD_TOAST:
      return state.add(action.toast);
    case REMOVE_TOASTS:
      return state.subtract(action.toasts);
    default:
      return state;
  }
}

export default toastReducer;
